var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComplex(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.4375,
    width: 44.4138,
    height: 44.4138,
    rx: 7.4023,
    fill: "#E1E1E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4922 22.6441C10.4922 17.1191 10.4922 14.3566 12.2086 12.6402C13.925 10.9238 16.6875 10.9238 22.2125 10.9238C27.7374 10.9238 30.5 10.9238 32.2164 12.6402C33.9328 14.3566 33.9328 17.1191 33.9328 22.6441C33.9328 28.1691 33.9328 30.9316 32.2164 32.6481C30.5 34.3644 27.7374 34.3644 22.2125 34.3644C16.6875 34.3644 13.925 34.3644 12.2086 32.6481C10.4922 30.9316 10.4922 28.1691 10.4922 22.6441Z",
    stroke: "#141B34",
    strokeWidth: 1.85057
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9766 16.4766H28.3789",
    stroke: "#141B34",
    strokeWidth: 1.85057,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0391 16.4766H17.2728",
    stroke: "#141B34",
    strokeWidth: 1.85057,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0391 22.6445H17.2728",
    stroke: "#141B34",
    strokeWidth: 1.85057,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0391 28.8125H17.2728",
    stroke: "#141B34",
    strokeWidth: 1.85057,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9766 22.6445H28.3789",
    stroke: "#141B34",
    strokeWidth: 1.85057,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9766 28.8125H28.3789",
    stroke: "#141B34",
    strokeWidth: 1.85057,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplex);
export default __webpack_public_path__ + "static/media/complex.9981f26cfa2f7d23102782e35323aca9.svg";
export { ForwardRef as ReactComponent };